import { useFormContext } from 'react-hook-form';
import usePropertySettingsInitData from '../usePropertySettingsInitData';
import { UnitListSchemaType } from './PropertySettingsUnitsTab.schema';

const useUnitManagement = () => {
  const { property } = usePropertySettingsInitData();
  const { getValues, setValue } = useFormContext<UnitListSchemaType>();

  const { name: unitTypeName } = property;

  const addUnits = (count: number) => {
    const units = getValues('units')!;
    const newUnits = Array.from({ length: count }, (_, index) => {
      const currentCount = units.length + index + 1;
      return {
        uid: `temp-${Date.now()}-${currentCount}`,
        name: `${unitTypeName} ${currentCount}`,
        isActive: true,
        isTemporary: true,
      };
    });
    setValue('units', [...units, ...newUnits], { shouldDirty: true });
  };

  const toggleUnitStatus = async (unitUid: string) => {
    const units = getValues('units')!;

    setValue(
      'units',
      units.map((u) =>
        u.uid === unitUid ? { ...u, isActive: !u.isActive } : u,
      ),
      { shouldDirty: true },
    );
  };

  const deleteUnit = async (unitUid: string) => {
    const units = getValues('units')!;

    setValue(
      'units',
      units.filter((u) => u.uid !== unitUid),
      { shouldDirty: true },
    );
  };

  return {
    addUnits,
    toggleUnitStatus,
    deleteUnit,
  };
};

export default useUnitManagement;
